import { Card } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomDataGrid from '../../../shared/components/CustomDataGrid';
import { handleError } from '../../../shared/functions/handleError';
import { useOfficeOrderlyColumns } from '../../../shared/hooks/useOfficeOrderlyColumns';
import { usePagination } from '../../../shared/hooks/usePagination';
import { IOfficeOrderly } from '../../../shared/interfaces/office-orderly/IOfficeOrderly';
import { AdminOfficeOrderlyService } from './service';

const AdminOfficeOrderly = () => {
  const {
    pagination,
    count,
    totalPages,
    setTotalPages,
    setCount,
    setPagination,
  } = usePagination({
    perPage: 10,
  });
  const [data, setData] = useState<IOfficeOrderly[]>([]);
  const columns = useOfficeOrderlyColumns();

  useEffect(() => {
    AdminOfficeOrderlyService.getAll(pagination)
      .then((response) => {
        setCount(response?.count);
        setData(response?.data);
        setTotalPages(Math.ceil(response?.count / response?.perPage));
      })
      .catch((err) => handleError(err));
  }, [pagination, setTotalPages, setCount]);
  return (
    <Card>
      <CustomDataGrid
        hasNextPage={totalPages < pagination?.page}
        rows={data || []}
        columns={columns}
        rowCount={count}
        pagination={pagination}
        setPagination={setPagination}
        loading={data === undefined}
      />
    </Card>
  );
};

export default AdminOfficeOrderly;
